import React, { useCallback } from 'react';
import config from '../config';

let isTawkLoaded = false;
export default class Tawk {
    static initializeTawk = () => {
        if (!config.tawk || !config.tawk.enabled) {
            return;
        }
        window.Tawk_API = window.Tawk_API || {};
        window.Tawk_API.onLoad = function () {
            Tawk.minimizeTawk();
            //alert('loaded');
        };
        const script = document.createElement('script');
        script.async = true;
        script.src = config.tawk.url;
        script.charset = 'UTF-8';
        script.setAttribute('crossorigin', '*');
        script.onload = () => (isTawkLoaded = true);
        document.head.appendChild(script);
    };

    static minimizeTawk = () => {
        if (isTawkLoaded) {
            window.Tawk_API.minimize();
        }
    };

    static maximizeTawk = () => {
        if (isTawkLoaded) {
            window.Tawk_API.maximize();
        }
    };

    static hideTawkWidget = () => {
        if (isTawkLoaded) {
            window.Tawk_API.hideWidget();
        }
    };

    static showTawkWidget = () => {
        if (isTawkLoaded) {
            window.Tawk_API.showWidget();
        }
    };

    static setTawkVisitorAttributes = attr => {
        if (isTawkLoaded) {
            window.Tawk_API.setAttributes({
                name: attr.name,
                email: attr.email,
                //etc.
            });
        }
    };
}

export function withTawk(Component) {
    function WithTawk(props) {
        const minimizeTawk = useCallback(() => Tawk.minimizeTawk(), []);
        const maxizimeTawk = useCallback(() => Tawk.maximizeTawk(), []);
        const setTawkVisitorAttributes = useCallback(
            () => Tawk.setTawkVisitorAttributes(),
            [],
        );
        const hideTawkWidget = useCallback(() => Tawk.hideTawkWidget(), []);
        const showTawkWidget = useCallback(() => Tawk.showTawkWidget(), []);

        return (
            <Component
                {...props}
                minimizeTawk={minimizeTawk}
                maxizimeTawk={maxizimeTawk}
                setTawkVisitorAttributes={setTawkVisitorAttributes}
                hideTawkWidget={hideTawkWidget}
                showTawkWidget={showTawkWidget}
            />
        );
    }

    WithTawk.displayName = `withTawk(${Component.displayName || Component.name || 'Component'})`;

    return WithTawk;
}
